import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { login, userService } from "../../_services/index.js";
//import giftsSvg from "../../Data/undraw_gifts.svg";

import BackgroundDecorations from "../Common/BackgroundDecorations";
import "./LoginFinal.css";

const LoginFinal = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const formRef = useRef();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errors, setErrors] = useState({});
    const [email, setEmail] = useState(location.state?.email || '');

    // Get current language direction
    const isRTL = i18n.language === 'he';

    const validateForm = (formData) => {
        const newErrors = {};

        if (!formData.get("email")) {
            newErrors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(formData.get("email"))) {
            newErrors.email = "Please enter a valid email";
        }

        if (!formData.get("password")) {
            newErrors.password = "Password is required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setErrors({});
        let loadingToastId = null;

        try {
            const form = formRef.current;
            if (!form) {
                toast.error("Form reference is missing!");
                return;
            }

            const formData = new FormData(form);

            if (!validateForm(formData)) {
                setIsSubmitting(false);
                return;
            }

            const email = formData.get("email");
            const password = formData.get("password");

            loadingToastId = toast.loading("Signing in...");
            const userData = await login(email, password);
            console.log(userData);
            // if no userData or null will be catched before it proceed to the next line
            if(userData.error){
                console.log(userData.error_description)
                if (userData.error === "unauthorized") {
                    if (loadingToastId) toast.dismiss(loadingToastId);
                    toast.dismiss();
                    toast("Incorrect email or password");
                    setIsSubmitting(false);
                    return;
                }
                else if(userData.error === "invalid_token"){
                    if (loadingToastId) toast.dismiss(loadingToastId);
                    toast.dismiss();
                    toast("Something Wrong, Please refresh the page and try again in a few moments!");
                    setIsSubmitting(false);
                    return;
                }else{
                    if (loadingToastId) toast.dismiss(loadingToastId);
                    toast.dismiss();
                    toast("Oops something went wrong, please try later!");
                    setIsSubmitting(false);
                    return;
                }
            }else if(!userData.hasOwnProperty('access_token')){
                if (loadingToastId) toast.dismiss(loadingToastId);
                toast.dismiss();
                toast("Oops something went wrong, please try again!");
                setIsSubmitting(false);
                return;
            }else {
                localStorage.setItem("user", JSON.stringify(userData));
                toast.dismiss();
                if (loadingToastId) toast.dismiss(loadingToastId);
                toast.success("Sign-in Successful");

                // Check if user has any clubs
                try {
                    const clubs = await userService.getAllClubsOfBusiness();
                    if (!clubs || clubs.length === 0) {
                        // First time login - redirect to ManageClubs
                        toast.info(t("welcomeToMyBenefitz"), {
                            position: "top-center",
                            autoClose: 8000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            style: {
                                fontSize: '1.3rem',
                                padding: '20px',
                                minWidth: '350px',
                                maxWidth: '550px',
                                lineHeight: '1.5',
                                textAlign: 'center'
                            }
                        });
                        navigate("/home/ManageClubs");
                    } else {
                        // Regular login - redirect to code page
                        navigate("/home/code");
                    }
                } catch (error) {
                    if (loadingToastId) toast.dismiss(loadingToastId);
                    console.error("Error checking clubs:", error);
                    toast.error("Failed to sign in. Please try again.");
                    // If there's an error checking clubs, default to code page
                    // navigate("/home/code");
                }
            }
        } catch (error) {
                toast.dismiss();
                console.error("Login error:", error);
                if (loadingToastId) toast.dismiss(loadingToastId);
                toast.error("Failed to sign in. Please try again.");

        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <BackgroundDecorations />
            <div className="login-container" dir={isRTL ? 'rtl' : 'ltr'}>
                <ToastContainer />

                {/* Add gift SVG with proper coloring */}
                <div style={{ isolation: 'isolate' }}>
                    {/*<img*/}
                    {/*    //src={giftsSvg}*/}

                    {/*    src={}*/}
                    {/*    className="login-gift-svg"*/}
                    {/*    alt="Gifts illustration"*/}
                    {/*/>*/}
                </div>

                {/* Header */}
                <div className="login-header">
                    <img
                        className="login-logo"
                        src="./images/Group 7571.png"
                        alt="Logo"
                    />
                </div>

                {/* Form Section */}
                <div className="login-form-container">
                    {/* Add accent line from design system */}
                    <div className="login-card-accent"></div>

                    <div className="login-form-header">
                        <h1>{t("loginTitle")}</h1>
                    </div>

                    <form ref={formRef} onSubmit={handleSubmit} className="login-form">
                        <div className="login-form-content">
                            <div className="login-form-row">
                                <div className="login-form-group">
                                    <label className="login-form-label">
                                        {t("email")} <span className="login-required">*</span>
                                        <div data-title="Email" className="login-helpDiv">
                                            <img
                                                className="login-help-icon"
                                                src="./images/yellow-mark.png"
                                                alt="Help"
                                            />
                                        </div>
                                    </label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder={t("emailPlaceholder")}
                                        className="login-form-input"
                                        dir={isRTL ? 'rtl' : 'ltr'}
                                    />
                                    {errors.email && <span className="login-error-message">{errors.email}</span>}
                                </div>

                                <div className="login-form-group">
                                    <label className="login-form-label">
                                        {t("password")} <span className="login-required">*</span>
                                        <div data-title="Password" className="login-helpDiv">
                                            <img
                                                className="login-help-icon"
                                                src="./images/yellow-mark.png"
                                                alt="Help"
                                            />
                                        </div>
                                    </label>
                                    <input
                                        type="password"
                                        name="password"
                                        placeholder={t("passwordPlaceholder")}
                                        className="login-form-input"
                                        dir={isRTL ? 'rtl' : 'ltr'}
                                    />
                                    {errors.password && <span className="login-error-message">{errors.password}</span>}
                                </div>
                            </div>
                        </div>

                        <div className="login-forgot-password">
                            <Link to="/forgot-password" className="login-forgot-password-link">
                                {t("forgotPassword")}
                            </Link>
                        </div>

                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className="login-submit-button"
                        >
                            {isSubmitting ? t("signingInMode") : t("loginMode")}
                        </button>

                        <div className="login-register-link">
                            {t("dontHaveAccount")}
                            <Link to="/Reg"> {t("createAccount")}</Link>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default LoginFinal;
